import { get } from "../../utils/httpClient";

const agencyService = () => {
  const prefixApi = "duedates/agencies";

  const getAgencies = async () => {
    return await get(`/${prefixApi}`);
  };

  return {
    getAgencies,
  };
};

export default agencyService;
